import React, {useEffect, useRef} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Input from "components/inputs/input"
import memo from "set-state-compare/build/memo"
import {Platform} from "react-native"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"

/** Unicorn filter date input with local controlled state. */
export default memo(shapeComponent(class ComponentsUserUnicornFilterDateInput extends ShapeComponent {
  static defaultProps = {
    testID: undefined
  }

  static propTypes = propTypesExact({
    externalValue: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    inputLanguage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onInputValueChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    testID: PropTypes.string,
    type: PropTypes.string.isRequired
  })

  /** @returns {void} */
  setup() {
    this.inputRef = useRef()
    this.useStates({
      inputKey: 0,
      value: this.p.externalValue
    })

    useEffect(() => {
      if (this.usesControlledValue()) {
        if (this.s.value == this.p.externalValue) {
          return
        }

        this.setState({value: this.p.externalValue})

        return
      }

      if (this.s.value == this.p.externalValue) {
        return
      }

      this.setState({
        inputKey: this.s.inputKey + 1,
        value: this.p.externalValue
      })
    }, [this.p.externalValue, this.p.inputLanguage, this.p.placeholder])
  }

  /** @returns {React.ReactNode} */
  render() {
    const inputProps = {
      id: this.p.id,
      inputRef: this.inputRef,
      lang: this.p.inputLanguage,
      name: this.p.name,
      onChange: this.tt.onChange,
      onClick: this.tt.onFocused,
      onFocus: this.tt.onFocused,
      placeholder: this.p.placeholder,
      style: this.inputStyle ||= {width: "100%"},
      testID: this.p.testID,
      type: this.p.type
    }

    if (this.usesControlledValue()) {
      inputProps.value = this.s.value
    } else {
      inputProps.defaultValue = this.s.value
      inputProps.key = `date-input-${this.s.inputKey}`
    }

    return (
      <Input {...inputProps} />
    )
  }

  /** @param {object} args */
  onChange = (args) => {
    const value = this.inputChangeValue(args)

    if (this.usesControlledValue()) {
      this.setState({value})
    }

    this.p.onInputValueChange(value)
  }

  /** @returns {void} */
  onFocused = () => {
    if (Platform.OS != "web" || this.p.type != "date") {
      return
    }

    if (typeof this.inputRef.current?.showPicker == "function") {
      this.inputRef.current.showPicker()
    }
  }

  /**
   * @param {object} args
   * @returns {string}
   */
  inputChangeValue(args) {
    const value = args?.target?.value ?? args?.currentTarget?.value ?? args?.nativeEvent?.text ?? args?.value ?? ""

    if (typeof value == "string") {
      return value
    }

    return ""
  }

  /** @returns {boolean} */
  usesControlledValue() {
    return this.p.type == "date"
  }
}))
